import { Translatable } from '@fmnts/api/shared';
import { FormFieldset } from './form-fieldset';
import { FormModal } from './form-modal';
import { FormNavigation } from './form-navigation';

export interface IFormPage {
  key: string;
  label: string | Translatable<string> | undefined;
  fieldsets: FormFieldset[];
  navigation: FormNavigation[];
  modals: readonly FormModal[];
}

export class FormPage {
  key: string;
  label: string | Translatable<string> | undefined;
  fieldsets: FormFieldset[];
  navigation: FormNavigation[];
  modals: readonly FormModal[];

  constructor(dto: Readonly<IFormPage>) {
    this.key = dto.key;
    this.label = dto.label;
    this.fieldsets = dto.fieldsets;
    this.navigation = dto.navigation;
    this.modals = dto.modals;
  }
}
